/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

function Footer() {
  return (
    <>
      <footer
        id="footer"
        className="footer bg-black-222"
        data-bg-img="images/footer-bg.png"
      >
        <div className="footer-bottom bg-black-333">
          <div className="container pt-20 pb-20">
            <div className="row">
              <div className="col-md-6">
                <h5 class="post-title mt-0 mb-5 text-white">ABOUT GO</h5>
                <p class="post-date mb-0 font-12 text-white">
                  IFRC GO is a Red Cross Red Crescent platform to connect
                  information on emergency needs with the right response.
                </p>
                <p className="font-11 text-white m-0">
                  Copyright &copy;2022 IFRC. Go platform
                </p>
              </div>
              <div className="col-md-6 text-right">
                <div className="widget no-border m-0 ">
                  <h5 class="post-title mt-0 mb-5 text-white ">CONTACT US</h5>
                  <a
                    class="btn btn-dark btn-theme-colored"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Contact us"
                    href="mailto:dm@redcross.mn"
                  >
                    dm@redcross.mn
                  </a>
                  <ul class="styled-icons icon-dark mt-20">
                    <li
                      
                    >
                      <a href="https://www.facebook.com/MongolianRedCrossSociety" data-bg-color="#3B5998" target={"_blank"} rel="noreferrer" >
                        <i class="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/mrcs_mn" data-bg-color="#02B0E8" target={"_blank"} rel="noreferrer">
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/user/RedCrossmn" data-bg-color="#C22E2A" target={"_blank"} rel="noreferrer">
                        <i class="fa fa-youtube"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <a className="scrollToTop" href="#">
        <i className="fa fa-angle-up"></i>
      </a>
    </>
  );
}

export default Footer;
